import { TextVariantType } from './types';

export const COLOR_MAPPING: Record<TextVariantType, string> = Object.freeze({
  default: 'var(--rhino)',
  warning: 'var(--red-dirt)',
});
